export default function Autocomplete(theme: any) {
  return {
    MuiSelect: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z20,
        },
        select: {
          "&.MuiSelect-multiple": {
            paddingRight: "0 !important",
          },
        },
      },
    },
  };
}
